import { render, staticRenderFns } from "./officeSuppliesCollectionAction.vue?vue&type=template&id=b289aab4&scoped=true"
import script from "./officeSuppliesCollectionAction.vue?vue&type=script&lang=js"
export * from "./officeSuppliesCollectionAction.vue?vue&type=script&lang=js"
import style0 from "./officeSuppliesCollectionAction.vue?vue&type=style&index=0&id=b289aab4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b289aab4",
  null
  
)

export default component.exports